import { CircularProgress, TextField } from "@mui/material";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { t } from "i18next";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { neutral } from "../../../constants/colorConstants";
import { MODULE_GROUP, STEPS } from "../../../constants/enums";
import { toastMessage } from "../../../helper";
import { getAssetService } from "../../../services/assetService";
import {
  createEmissionService,
  getEmissionTypesService,
} from "../../../services/emissionService";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";

const AssetActivityData = (props: any) => {
  const {
    selectedAssetsData,
    setStep,
    setEmissionData,
    emissionData,
    isDirectEmissionApprovalEnable,
  } = props;
  const [emissionMethod, setEmissionMethod] = useState<any>({});
  const [sourceName, setSourceName] = useState("NA");
  const getUomName = (symbol: string) => {
    if (symbol.includes("kg CO2/")) {
      return symbol.split("kg CO2/")[1];
    } else if (symbol.includes("kg CO2e/")) {
      return symbol.split("kg CO2e/")[1];
    } else return symbol;
  };
  const [formData, setFormData] = useState<any>({
    company:
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id,
    businessUnit:
      localStorage.getItem("currentBusinessUnit") &&
      JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    method: "",
    scope: "",
    parent: "",
    attachments: [],
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 2),
    to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    category: "",
    categoryCode: "",
    comments: "",
    value: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const isValidForm = () => {
    return formData.from && formData.to && formData.value;
  };
  const onChangeDate = (e: any) => {
    if (!e) {
      setFormData({ ...formData, from: null, to: null });
      return;
    }
    console.log(e);
    console.log(e.$d);
    let startDate = new Date(e.$d);
    console.log("startDate before", startDate);
    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 2);
    startDate.setHours(0, 0, 0, 0);
    console.log("startDate after", startDate);

    let endDate = new Date(e.$d);
    console.log("endDate before", endDate);
    endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    console.log("endDate after", endDate);
    endDate.setHours(0, 0, 0, 0);
    setFormData({ ...formData, from: startDate, to: endDate });
  };
  const [assetsDetail, setAssetsDetail] = useState({} as any);
  const [sourceList, setSourceList] = useState([] as any);
  const navigate = useNavigate();
  const getEmissionType = (reqObj: any) => {
    return getEmissionTypesService(reqObj).then((res) => res);
  };
  const getSourcename = (data: any) => {
    const { emission_source, emission_sub_source, engine, fuel } = data;
    let sourceName = "";
    if (emission_source) {
      sourceName += emission_source;
    }
    if (emission_sub_source) {
      sourceName += " - ";
      sourceName += emission_sub_source;
    }
    if (engine) {
      sourceName += " ";
      sourceName += engine;
    }
    if (fuel) {
      sourceName += "-";
      sourceName += fuel;
    }
    return sourceName;
  };
  const createEmissionLog = () => {
    setIsLoading(true);
    let reqData: any = formData;
    reqData.from.setHours(0, 0, 0, 0);
    reqData.to.setHours(0, 0, 0, 0);
    console.log("reqData", reqData);
    let user = JSON.parse(localStorage.getItem("user") || "{}");
    reqData.displayName = user.displayName
      ? user.displayName
      : user.email.split("@")[0];
    let activeList = sourceList
      .filter((eachSource: any) => eachSource.selected)
      .map((src: any) => {
        let eachSource = { ...src };
        eachSource.emissionSource = eachSource.emissionsource;
        let uom = eachSource.uoms && eachSource.uoms[0];
        if (eachSource.uoms?.length > 1) {
          uom = { id: eachSource.uom, symbol: eachSource.symbol };
        }
        eachSource.uoms ? delete eachSource.uoms : delete eachSource.uomsymbol;
        delete eachSource.emissionsource;
        delete eachSource.emissionmethodname;
        uom && (eachSource.uom = uom.id);
        eachSource.value = eachSource.units;
        eachSource.uomName = uom
          ? uom.symbol
            ? uom.symbol
            : uom.name
          : eachSource.uomsymbol;
        eachSource.attachments = { files: eachSource.attachments };
        eachSource.symbol = uom
          ? uom.symbol
            ? uom.symbol
            : uom.name
          : eachSource.uomsymbol;
        return eachSource;
      });
    reqData.emissionSources = activeList;
    reqData.status = isDirectEmissionApprovalEnable ? "Approved" : "Pending";
    let req = { ...reqData };
    req.attachments = { files: req.attachments };
    reqData.protocol = localStorage.getItem("protocol");
    delete req.country;
    createEmissionService(req)
      .then((res) => {
        setEmissionData({ ...res.data, local_code: selectedAssetsData.code });
        toastMessage("Emission Log Creation Successful", "success");
        setStep(STEPS.EMISSION_SUMMARY);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const onChangeUnits = (e: any) => {
    setFormData({
      ...formData,
      value:
        e.target.value === ""
          ? ""
          : !isNaN(e.target.value) && parseInt(e.target.value) > 0
          ? parseInt(e.target.value)
          : formData.value,
    });
  };
  useEffect(() => {
    setEmissionData({ ...emissionData, local_code: selectedAssetsData.code });
    getAssetService({ id: selectedAssetsData.id })
      .then((res: any) => {
        const assetData = res.data.asset;
        setAssetsDetail(res.data.asset);
        const reqObj = {
          method: assetData.emission_method_id,
          type: assetData.emission_type_id,
          subtype: assetData.emission_sub_type_id,
        };
        getEmissionType(reqObj)
          .then((res) => {
            const emissionMethod = res.data.find(
              (eachType: any) => eachType.moduleGroup === MODULE_GROUP.GROUP_2
            );
            setEmissionMethod(emissionMethod);
            setSourceName(
              res.data.find(
                (eachType: any) =>
                  eachType.moduleGroup === MODULE_GROUP.GROUP_19 ||
                  eachType.moduleGroup === MODULE_GROUP.GROUP_15
              ).name
            );
          })
          .catch((e) => {
            console.log(e);
          });
        const updatedFormData = {
          ...formData,
          type: assetData.emission_type_id,
          subType: assetData.emission_sub_type_id,
          method: assetData.emission_method_id,
          enginetype: assetData.engine_id,
          uom: assetData.uom,
          uomName: assetData.uom_name,
          fuel: assetData.fuel_id || null,
          asset: selectedAssetsData.id,
          assetCode: selectedAssetsData.generatedCode,
          category: assetData.emission_category_id,
          categoryCode: assetData.emission_category_code,
          emissionSource: assetData.emission_source_id,
          scope: assetData.scope || null,
        };
        if (assetData.emission_sub_source_id) {
          updatedFormData["emissionsourcesubtype"] =
            assetData.emission_sub_source_id;
        }
        setFormData({ ...updatedFormData });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <Fragment>
      <div className="pw-activity-data-main w-55v overflow-y-auto flex flex-col gap-10">
        <div>
          <div className="pw-input-label pw-create-label">
            {t("Log Values")}
          </div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {t("Preferred emission factor")}
              </p>
              <p className="text-sm text-neutral-900">{sourceName || "-"}</p>
            </div>
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {t("Log emission against")}
              </p>
              <p className="text-sm text-neutral-900">
                {emissionMethod?.name || "-"}
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="pw-range-label pb-1.5 text-neutral-600">
            {t("Range")}
          </div>
          {/* <RangePicker 
                className="pw-date-range"
                picker="month"
                onChange={onChangeDate}
              /> */}
          <DatePicker
            picker="month"
            className="pw-date-range bg-white"
            defaultValue={dayjs(formData.from)}
            onChange={onChangeDate}
          />
        </div>
        <div>
          <div className="flex pw-pr-228 justify-between pw-bg-neutral-50 pw-text-neutral-600 p-2">
            <div>Assets ID</div>
            <div>Activtiy Data</div>
          </div>
          <div className="flex justify-between pw-bg-white pw-text-neutral-600 py-4 px-2 pr-40">
            <div>
              <div className="pw-text-neutral-900">
                {selectedAssetsData.code}
              </div>
              <div
                style={{ fontSize: "12px" }}
                className=" pw-text-neutral-600 "
              >
                {getSourcename(assetsDetail)}
              </div>
            </div>

            <div className="flex gap-x-4">
              <TextField
                sx={{ input: { textAlign: "right" } }}
                type="text"
                variant="standard"
                placeholder="units"
                size="small"
                name="units"
                onChange={onChangeUnits}
                value={formData.value}
                className="pw-width-100 pw-input-field pw-input-text pw-activity-input"
                InputProps={{
                  style: {
                    color: neutral[900],
                    fontSize: 14,
                  },
                }}
              />
              <span>
                {assetsDetail?.uom_name?.length > 0 &&
                  getUomName(assetsDetail.uom_name)}
              </span>
            </div>
          </div>
        </div>
        <div>
          {" "}
          <FileAttachmentsDetails
            formData={formData}
            setFormData={setFormData}
          />
        </div>
        <div className="flex flex-col gap-2 items-start">
          <p className="text-sm text-neutral-600">{t("Notes")}</p>
          <textarea
            name="comments"
            className="pw-notes-area pw-address"
            placeholder={t("Notes")}
            value={formData.comments}
            onChange={(e) =>
              setFormData({ ...formData, comments: e.target.value })
            }
          ></textarea>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={() => {
            navigate("/log/emissions", {
              state: {
                type: STEPS.ASSETS,
              },
            });
          }}
        >
          {t("Cancel")}
        </div>
        <button
          id="pw-e2e-emissionassetsavebtn"
          className={`pw-bunit-button-primary pw-bunit-button-save text-white  
              ${
                isValidForm()
                  ? isLoading
                    ? "text-black bg-neutral-300"
                    : "cursor-pointer bg-primary"
                  : "text-black bg-neutral-300"
              }`}
          onClick={() => {
            isValidForm() && createEmissionLog();
          }}
          disabled={!isValidForm()}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{t("Saving up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Save")}</span>
          )}
        </button>
      </div>
    </Fragment>
  );
};
export default AssetActivityData;
